/** Trigger the OS print dialog with only the QMS token receipt visible.
 *  `index.css` hides everything outside `.qms-print-host` while
 *  `body.qms-print-armed` is set; we set the class, print, then clear it
 *  on `afterprint` — with a timeout fallback because Safari sometimes
 *  skips that event. */
export function printReceipt(): void {
  const body = document.body;
  body.classList.add('qms-print-armed');
  const cleanup = (): void => {
    body.classList.remove('qms-print-armed');
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup, { once: true });
  window.setTimeout(cleanup, 2_000);
  window.print();
}
